import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b25427d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "map-content-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $props.title,
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["StreetView"], {
        latitude: $props.latitude,
        longitude: $props.longitude
      }, null, 8 /* PROPS */, ["latitude", "longitude"])
    ])
  ]))
}